// Side-effect import: runs `Sentry.init` before `@/router` is evaluated, so
// the React Router v7 tracing integration is registered before the router is
// created (otherwise the initial pageload transaction is lost). Keep first.
import "@/lib/sentry";

import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";

import { queryClient } from "@/lib/query";
import { router } from "@/router";
import "@/index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </React.StrictMode>,
);
